// currency-symbol.token.ts
import { InjectionToken, inject, LOCALE_ID } from '@angular/core';

function getCurrencySymbolIntl(locale: string, currency: string): string {
  const parts = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).formatToParts(0);

  const currencyPart = parts.find(part => part.type === 'currency');
  return currencyPart ? currencyPart.value : currency;
}

/**
 * Maps locales to default currency codes.
 * You can extend this as needed.
 */
function getCurrencyCodeFromLocale(locale: string): string {
  const normalized = locale.toLowerCase();

  // Eurozone
  if (
    normalized.startsWith('fr') ||
    normalized.startsWith('be') || // Belgique
    normalized.startsWith('lu') || // Luxembourg
    normalized.startsWith('es') ||
    normalized.startsWith('de') ||
    normalized.startsWith('it') ||
    normalized.startsWith('ie') ||
    normalized.startsWith('pt') ||
    normalized.startsWith('nl')
  )
    return 'EUR';

  // Suisse
  if (normalized.startsWith('ch')) return 'CHF';

  // Royaume-Uni
  if (normalized.startsWith('en-gb')) return 'GBP';

  // États-Unis
  if (normalized.startsWith('en-us')) return 'USD';

  // Canada
  if (normalized.startsWith('en-ca') || normalized.startsWith('fr-ca')) return 'CAD';

  // Japon
  if (normalized.startsWith('ja')) return 'JPY';

  // Par défaut : euro
  return 'EUR';
}

/**
 * Only use it to display currency symbol in templates.
 * For formatting currency values, use Angular CurrencyPipe or Intl.NumberFormat directly.
 */
export const CURRENCY_SYMBOL = new InjectionToken<string>('CurrencySymbol', {
  providedIn: 'root',
  factory: () => {
    const locale = inject(LOCALE_ID);
    const code = getCurrencyCodeFromLocale(locale);
    return getCurrencySymbolIntl(locale, code);
  },
});
